import React, { Component } from 'react'
import { TextField } from 'material-ui'
import { InformationIcon } from './'

import * as Constants from '../../helpers/Constants'

class TextInput extends Component {
  getValue() {
    return this.refs.input.getValue()
  }

  render() {
    const {
      header = '',
      type = 'text',
      value,
      onChange = () => {},
      defaultValue = '',
      disabled,
      width = 256,
      height,
      maxLength,
      underlineStyle,
      underlineFocusStyle,
      floatingLabelFocusStyle,
      marginLeft = 0,
      marginRight = 0,
      marginTop = 0,
      inputStyle,
      floatingLabelStyle,
      maxWidth,
      iconColor = Constants.WHITE_LABEL.colors.primary,
      iconHoverColor = Constants.WHITE_LABEL.colors.primaryHover,
      showHelpIcon = false,
      onIconPressed,
      multiline,
      rows,
      rowsMax
    } = this.props
    const { labelStyle, focusedUnderlineStyle, diasbledUnderlineStyle } = styles
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width,
          maxWidth,
          marginLeft,
          marginRight,
          marginTop
        }}
      >
        <TextField
          multiLine={multiline}
          rows={rows}
          rowsMax={rowsMax}
          ref={'input'}
          floatingLabelStyle={
            floatingLabelStyle ? floatingLabelStyle : labelStyle
          }
          floatingLabelFocusStyle={
            floatingLabelFocusStyle ? floatingLabelFocusStyle : labelStyle
          }
          underlineFocusStyle={
            underlineFocusStyle ? underlineFocusStyle : focusedUnderlineStyle
          }
          underlineStyle={
            underlineStyle ? underlineStyle : diasbledUnderlineStyle
          }
          inputStyle={inputStyle}
          floatingLabelText={header}
          type={type}
          value={value}
          onChange={(event, newValue) => onChange(newValue)}
          defaultValue={defaultValue}
          disabled={disabled}
          style={{
            flex: 1,
            marginRight: showHelpIcon ? 15 : 0,
            height: height ? height : '72px'
          }}
          maxLength={maxLength}
        />
        {showHelpIcon ? (
          <InformationIcon
            color={iconColor}
            hoverColor={iconHoverColor}
            onClick={() => onIconPressed()}
          />
        ) : null}
      </div>
    )
  }
}

const styles = {
  labelStyle: {
    color: 'rgba(0, 0, 0, 0.3)'
  },
  focusedUnderlineStyle: {
    borderColor: '#3b424d'
  },
  diasbledUnderlineStyle: {
    borderColor: '#3b424d'
  }
}

export { TextInput }



// WEBPACK FOOTER //
// ./src/components/common/TextInput.js